import script from "./TraitShopTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopTabs.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopTabs.vue?vue&type=style&index=0&id=4964ac68&lang=scss"

const __exports__ = script;

export default __exports__